import { createActionGroup, props } from '@ngrx/store';
import { DefaultDraftItem } from '../../models/default-draft-template.model';

export const PlanningDefaultDraftsApiActions = createActionGroup({
  source: 'Planning Default Drafts API',
  events: {
    // Get default drafts
    getDefaultDrafts: props<{ params?: any }>(),
    getDefaultDraftsSuccess: props<{ drafts: DefaultDraftItem[], cursor?: string }>(),
    getDefaultDraftsFailure: props<{ error: any }>(),

    // Update default draft
    updateDefaultDraft: props<{ id: string, payload: any }>(),
    updateDefaultDraftSuccess: props<{ draft: DefaultDraftItem }>(),
    updateDefaultDraftFailure: props<{ error: any }>(),

    // Rename default draft
    renameDefaultDraft: props<{ id: string, payload: any }>(),
    renameDefaultDraftSuccess: props<{ draft: DefaultDraftItem }>(),
    renameDefaultDraftFailure: props<{ error: any }>(),

    // Delete default draft
    deleteDefaultDraft: props<{ id: string }>(),
    deleteDefaultDraftSuccess: props<{ id: string }>(),
    deleteDefaultDraftFailure: props<{ error: any }>(),

    // Clear store
    clearStore: props<{ force?: boolean }>()
  }
});
